export const orderRequirements = {
  minPlateWells: 24
};

export const genomeOptions = [
  {
    label: 'Homo sapiens',
    commonName: 'human',
    slug: 'homo_sapiens'
  },
  {
    label: 'Mus musculus',
    commonName: 'mouse',
    slug: 'mus_musculus'
  },
  {
    label: 'Other',
    commonName: 'other',
    slug: 'other'
  }
];

//These are just used to populate new plates and tubes, available quanities are fetched from API
export const defaultYieldOptions = {
  sgrna_kit: {
    plates: { display: '1.5 nmol', id: '1.5nmol' },
    tubes: { display: '3 nmol', id: '3nmol' }
  },
  custom_rna: {
    plates: { display: '5 nmol', id: '5nmol' },
    tubes: { display: '5 nmol', id: '5nmol' }
  }
};

export const defaultNucleaseOptions = {
  sgrna_kit: 'SpCas9',
  custom_rna: 'Other'
};

export const defaultPurificationOption = {
  id: 'spe',
  display: 'Standard'
};

export const defaultModificationsOption = {
  id: 'standard',
  display: 'Standard'
};

export const formatOptions = {
  sgrna_kit: [
    {
      label: 'Tubes',
      caption: 'Includes tubes of Tris-EDTA Buffer\n and Nuclease-free Water',
      shortCaption: '',
      slug: 'tubes'
    },
    {
      label: 'Plates',
      caption: '96 Well Plates,\n Minimum of 24 filled wells per plate',
      shortCaption: '96 Well',
      slug: 'plates'
    }
  ],
  custom_rna: [
    {
      label: 'Tubes',
      caption: '',
      shortCaption: '',
      slug: 'tubes'
    },
    {
      label: 'Plates',
      caption: '96 Well Plates,\n Minimum of 24 filled wells per plate',
      shortCaption: '96 Well',
      slug: 'plates'
    }
  ]
};

export const NUCLEASE_DISPLAY_MAP = {
  AccuBase: 'AccuBase™',
  'eSpOT-ON': 'eSpOT-ON',
  SpCas9: 'SpCas9',
  hfCas12Max: 'hfCas12Max',
  Other: 'Other'
};

export const plateOptions = [
  {
    label: '96-well',
    caption: 'Polypropylene',
    slug: '1mL deep well',
    wellCount: 96,
    wellRows: 8,
    wellColumns: 12
  }
];

export const sequenceHelpText = {
  //Edit helper text
  sgrna_kit: {
    SpCas9: {
      text:
        "SpCas9 gRNA Target Sequence is 5-35 nucleotides in length. Enter in 5' to 3' orientation.",
      tooltip:
        "We will automatically add an 80-nt SpCas9 scaffold to create a single guide RNA. For 5' modifications, internal modifications, 3' modifications, or mixed nucleotides please contact us."
    },
    AccuBase: {
      text:
        "AccuBase™ gRNA Target Sequence is 17-23 nucleotides in length. Enter in 5' to 3' orientation.",
      tooltip:
        "We will automatically add an 80nt AccuBase™ scaffold to create a single guide RNA. For 5' modifications, internal modifications, 3' modifications, or mixed nucleotides please contact us."
    },
    hfCas12Max: {
      text:
        "hfCas12Max gRNA Target sequence is 17-23 nucleotides in length. Enter in 5' to 3' orientation.",
      tooltip:
        'We will automatically add a 23-nt hfCas12Max scaffold to create a single guide RNA. It will be prepended to the beginning of your target sequence.'
    },
    'eSpOT-ON': {
      text:
        "eSpOT-ON gRNA Target sequence is 19-23 nucleotides in length. Enter in 5' to 3' orientation.",
      tooltip:
        'We will automatically add a 80-nt eSpOT-ON scaffold to create a single guide RNA. It will be appended to the end of your target sequence.'
    }
  },
  custom_rna: {
    Other: {
      text: 'Full-length sequence can be 20-115 nucleotides long',
      tooltip:
        "Enter the desired RNA sequence 5' -> 3'. For RNA longer than 115 nucleotides, 5' modifications, internal modifications, 3' modifications, or mixed nucleotides please contact our sales team."
    },
    hfCas12Max: {
      text:
        "hfCas12Max gRNA Target sequence is 17-23 nucleotides in length. Enter in 5' to 3' orientation.",
      tooltip:
        'We will automatically add a 23-nt hfCas12Max scaffold to create a single guide RNA. It will be prepended to the beginning of your target sequence.'
    },
  },
  multiplex_sgrna: {
    'eSpOT-ON': {
      text:
        "eSpOT-ON gRNA Target sequence is 19-23 nucleotides in length. Enter in 5' to 3' orientation.",
      tooltip:
        'We will automatically add a 80-nt eSpOT-ON scaffold to create a single guide RNA. It will be appended to the end of your target sequence.'
    }
  }
};

export const unifiedSequenceHelpText = [
  {
    nuclease: 'SpCas9',
    modification: 'standard',
    text: "SpCas9 gRNA target sequence is 5 - 35 bases in length. Enter 5' to 3' without the PAM.",
    tooltip: "Only enter target sequence in 5' to 3' orientation. We will automatically add an 80 base SpCas9 scaffold to create a single guide RNA. Scaffold will be added to the 3' end of your target sequence.",
    input_field: "Example: CUCUCAGCUGGUACACGGCA"
  },
  {
    nuclease: 'SpCas9',
    modification: 'none',
    text: "SpCas9 gRNA target sequence is 5 - 35 bases in length. Enter 5' to 3' without the PAM.",
    tooltip: "Only enter target sequence in 5' to 3' orientation. We will automatically add an 80 base SpCas9 scaffold to create a single guide RNA. Scaffold will be added to the 3' end of your target sequence.",
    input_field: "Example: CUCUCAGCUGGUACACGGCA"
  },
  {
    nuclease: 'SpCas9',
    modification: 'other',
    text: "The sequence is synthesized exactly as shown. Full-length sequence includes target sequence and scaffold/constant sequence. Exclude the PAM in sequence. Enter full-length gRNA sequences with chemical modifications included. Full-length sequence can be 81 - 115 bases long.",
    tooltip: "Must include full-length sequence in 5' to 3' orientation with m and * chemical modification at designated locations in sequence. Full-length sequence includes target sequence and scaffold/constant sequence.",
    input_field: "Example: mC*U*C*UCAGCUGGUACACGGCAGUUUUAGAGCUAGAAAmUmAmGCAAGUUAAAAUAAGG..."
  },
  {
    nuclease: 'AccuBase',
    modification: 'standard',
    text: "AccuBase™ gRNA target sequence is 17 - 23 bases in length. Enter 5' to 3' without the PAM.",
    tooltip: "Only enter target sequence in 5' to 3' orientation. We will automatically add an 80 base Accubase™ scaffold to create a single guide RNA. Scaffold will be added to the 3' end of your target sequence.",
    input_field: "Example: UUCGUAUCUGUAAAACCAAG"
  },
  {
    nuclease: 'AccuBase',
    modification: 'none',
    text: "AccuBase™ gRNA target sequence is 17 - 23 bases in length. Enter 5' to 3' without the PAM.",
    tooltip: "Only enter target sequence in 5' to 3' orientation. We will automatically add an 80 base Accubase™ scaffold to create a single guide RNA. Scaffold will be added to the 3' end of your target sequence.",
    input_field: "Example: UUCGUAUCUGUAAAACCAAG"
  },
  {
    nuclease: 'AccuBase',
    modification: 'other',
    text: "The sequence is synthesized exactly as shown. Full-length sequence includes target sequence and scaffold/constant sequence. Exclude the PAM in sequence. Enter full-length gRNA sequences with chemical modifications included. Full-length sequence can be 20 - 115 bases long.",
    tooltip: "Must include full-length sequence in 5' to 3' orientation with m and * chemical modification at designated locations in sequence. Full-length sequence includes target sequence and scaffold/constant sequence.",
    input_field: "Example: mC*U*C*UCAGCUGGUACACGGCAGUUUUAGAGCUAGAAAmUmAmGCAAGUUAAAAUAAGG..."
  },
  {
    nuclease: 'hfCas12Max',
    modification: 'standard',
    text: "hfCas12Max gRNA target sequence is 17 - 23 bases in length. Enter 5' to 3' without the PAM.",
    tooltip: "Only enter target sequence in 5' to 3' orientation. We will automatically add a 23 base hfCas12Max scaffold to create a single guide RNA. Scaffold will be added to the 5' end of your target sequence.",
    input_field: "Example: GAGUCUCUCAGCUGGUACAC"
  },
  {
    nuclease: 'eSpOT-ON',
    modification: 'standard',
    text: "eSpOT-ON gRNA target sequence is 20 - 22 bases in length. Enter 5' to 3' without the PAM.",
    tooltip: "Only enter target sequence in 5' to 3' orientation. We will automatically add an 87 base eSpOT-ON scaffold to create a single guide RNA. Scaffold will be added to the 3' end of your target sequence.",
    input_field: "Example: GGUCAGGGUUCUGGAUAUCUGU"
  },
  {
    nuclease: 'Other',
    modification: 'standard',
    text: "The sequence is synthesized exactly as shown. Full-length sequence includes target sequence and scaffold/constant sequence. Exclude the PAM in sequence. Full-length sequence can be 20 - 119 bases long.",
    tooltip: "Must include full-length sequence in 5' to 3' orientation. Full-length sequence includes target sequence and scaffold/constant sequence.",
    input_field: "Example: UAAUUUCUACUCUUGUAGAUACCGCCCAACAUGGCCUCGG"
  },
  {
    nuclease: 'Other',
    modification: 'none',
    text: "The sequence is synthesized exactly as shown. Full-length sequence includes target sequence and scaffold/constant sequence. Exclude the PAM in sequence. Full-length sequence can be 20 - 119 bases long.",
    tooltip: "Must include full-length sequence in 5' to 3' orientation. Full-length sequence includes target sequence and scaffold/constant sequence.",
    input_field: "Example: UAAUUUCUACUCUUGUAGAUACCGCCCAACAUGGCCUCGG"
  },
  {
    nuclease: 'Other',
    modification: 'other',
    text: "The sequence is synthesized exactly as shown. Full-length sequence includes target sequence and scaffold/constant sequence. Exclude the PAM in sequence. Enter full-length gRNA sequences with chemical modifications included. Full-length sequence can be 20 - 119 bases long.",
    tooltip: "Must include full-length sequence in 5' to 3' orientation with m and * chemical modification at designated locations in sequence. Full-length sequence includes target sequence and scaffold/constant sequence.",
    input_field: "Example: mU*mA*mA*UUUCUACUCUUGUmAmGmAUACC*G*CCCAACAUGGCCUCGG"
  }
];

export const warningColor = '#ffca28';

export const ERRORS = {
  SEQUENCE_INVALID: 'SEQUENCE_INVALID',
  NAME_INVALID: 'NAME_INVALID',
  NAME_NON_UNIQUE: 'NAME_NON_UNIQUE',
  NAME_EXISTS_IN_CART: 'NAME_EXISTS_IN_CART',
  YIELD_INVALID: 'YIELD_INVALID',
  MODIFICATION_INVALID: 'MODIFICATION_INVALID',
  POSITION_INVALID: 'POSITION_INVALID',
  PURIFICATION_INVALID: 'PURIFICATION_INVALID'
};

export const hfCas12MaxBlockedCountries = ['CN'];
